import api from '@/apis';

export const fetchList = (tenantId, params = {}) =>
  api.get(`/tenants/${tenantId}/staffs`, { params });
export const setActiveState = (id, isActive) =>
  api.put(`/staffs/${id}/set_active`, { isActive });
